module.exports = __webpack_public_path__ + "media/apple-badge.7af92948.svg";